import React from 'react'
import PropTypes from 'prop-types'
import FilterInput from "./FilterInput"

CustomerFilters.propTypes = {
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    onChangeInput: PropTypes.func.isRequired
}

function CustomerFilters(props) {
    const {name, email, phone, onChangeInput} = props

    return (
        <div className="PageFilters">
            <FilterInput label="Name" name="name" placeholder="Search name..." value={name}
                         onChangeInput={onChangeInput}/>
            <FilterInput label="Email" name="email" placeholder="Search email..." value={email}
                         onChangeInput={onChangeInput}/>
            <FilterInput label="Phone" name="phone" placeholder="Search phone..." value={phone}
                         onChangeInput={onChangeInput}/>
        </div>
    )
}

export default CustomerFilters
